import { ILoggerDeployment } from '@app/api/interfaces/logger-deployment-data.interface';
import { ILoggerMeasurement } from '@app/api/interfaces/logger-measurement.interface';

export function getMeasurementsMapToDeployment(measurements: ILoggerMeasurement[]): Record<string, string[]> {
  return measurements.reduce(
    (acc, measurement) => {
      const deploymentId = measurement.deploymentId;
      if (!acc[deploymentId]) {
        acc[deploymentId] = [];
      }

      acc[deploymentId].push(measurement.id);

      return acc;
    },
    {} as Record<string, string[]>
  );
}

export function getLoggerSerialNoMapToMeasurements(
  loggerDeployments: ILoggerDeployment[],
  measurements: ILoggerMeasurement[]
): Record<string, string[]> {
  const measurementsMapToDeployment = getMeasurementsMapToDeployment(measurements);

  return loggerDeployments.reduce(
    (acc, loggerDeployment) => {
      const serialNo = loggerDeployment.serialNo;
      if (!acc[serialNo]) {
        acc[serialNo] = [];
      }

      const relatedMeasurementIds = measurementsMapToDeployment[loggerDeployment.id] || [];

      acc[serialNo] = [...new Set([...acc[serialNo], ...relatedMeasurementIds])];

      return acc;
    },
    {} as Record<string, string[]>
  );
}
